<admin-app-header></admin-app-header>
<br />

<div class="container">
    <div class="row">
        <div class="col-12">
            <h1 class="mb-0">Create Subscription on Behalf of Client</h1>
            <p class="text-muted">
                This sends the request on the client's saved card. Nothing is charged until the landlord accepts.
            </p>
        </div>
    </div>

    <div class="col-12">
        <form (ngSubmit)="onSubmit()" [formGroup]="formData" autocomplete="off" novalidate>
            <!-- Client -->
            <div class="row">
                <div class="form-group col-4">
                    <label>Client Name</label>
                    <input
                        (typeaheadOnSelect)="onClientSelect($event.item)"
                        [typeaheadItemTemplate]="clientTemplate"
                        [typeaheadOptionField]="'firstName'"
                        [typeahead]="clientLookup"
                        class="form-control"
                        formControlName="clientName"
                        placeholder="Search for a Client"
                        type="text"
                    />
                    <ng-template #clientTemplate let-index="index" let-model="item">
                        {{ model.firstName }} {{ model.lastName }}
                        <ng-container *ngIf="model.companyName"> - {{ model.companyName }} </ng-container>
                    </ng-template>
                </div>

                <div class="form-group col-4">
                    <label>Confirm Client Email</label>
                    <input [attr.disabled]="true" class="form-control" formControlName="confirmClientEmail" type="text" />
                </div>
                <div class="form-group col-4">
                    <label>Confirm Client Phone</label>
                    <input [attr.disabled]="true" class="form-control" formControlName="confirmClientPhone" type="text" />
                </div>
            </div>

            <!-- Payment method selector -->
            <div class="row mt-3" *ngIf="clientKey">
                <div class="col-12">
                    <label><strong>Client's Vaulted Card</strong> <span class="text-danger">*</span></label>

                    <div *ngIf="!paymentMethodsLoaded" class="text-muted">Loading saved cards...</div>

                    <div *ngIf="noCardOnFile" class="alert alert-warning d-flex align-items-center" role="alert">
                        <i class="fa-solid fa-triangle-exclamation me-2"></i>
                        <div>
                            <strong>This client has no card on file.</strong> They must add a card via their dashboard
                            before an admin can create a subscription on their behalf.
                        </div>
                    </div>

                    <div *ngIf="hasCardOnFile" class="payment-methods-list">
                        <div
                            *ngFor="let method of availablePaymentMethods"
                            class="payment-method-row"
                            [class.selected]="selectedPaymentMethod?.$key === method.$key"
                            (click)="selectPaymentMethod(method)"
                        >
                            <div class="payment-method-row__radio">
                                <i
                                    [class]="
                                        selectedPaymentMethod?.$key === method.$key
                                            ? 'fa-solid fa-circle-dot'
                                            : 'fa-regular fa-circle'
                                    "
                                ></i>
                            </div>
                            <div class="payment-method-row__icon">
                                <i [class]="'fa-brands ' + method.icon"></i>
                            </div>
                            <div class="payment-method-row__body">
                                <div class="payment-method-row__card-no">{{ method.cardNo }}</div>
                                <div class="payment-method-row__meta">
                                    <span *ngIf="method.nameOnCard">{{ method.nameOnCard }}</span>
                                    <span *ngIf="method.cardType"> · {{ method.cardType }}</span>
                                    <span *ngIf="method.primary" class="badge bg-primary ms-2">Primary</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Parking -->
            <div class="row mt-3">
                <div class="form-group col-6">
                    <label>Parking Name</label>
                    <input
                        (typeaheadOnSelect)="onParkingSelect($event.item)"
                        [typeaheadItemTemplate]="parkingTemplate"
                        [typeaheadOptionField]="'title'"
                        [typeahead]="parkingLookup"
                        class="form-control"
                        formControlName="parkingName"
                        placeholder="Search for a Parking"
                        type="text"
                    />
                    <ng-template #parkingTemplate let-index="index" let-model="item">
                        {{ model.title }}
                    </ng-template>
                </div>

                <div class="form-group col-6">
                    <label>Portfolio</label>
                    <input [attr.disabled]="true" class="form-control" formControlName="confirmMerchantCompanyName" type="text" />
                </div>
            </div>

            <!-- Dates -->
            <div class="row mt-3">
                <div class="form-group col-4">
                    <label>Start Date <span class="text-danger">*</span> (date of first invoice)</label>
                    <input class="form-control" formControlName="startDate" type="date" />
                </div>

                <div class="form-group col-4">
                    <label>Contract Duration <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" formControlName="contractLength" min="1" type="number" />
                        <div class="input-group-text">
                            <span>Months</span>
                        </div>
                    </div>
                </div>

                <div class="form-group col-4">
                    <label>End Date</label>
                    <input [attr.disabled]="true" class="form-control" formControlName="endDate" type="date" />
                </div>
            </div>

            <!-- Bays + price -->
            <div class="row mt-3">
                <div class="form-group col-6">
                    <label>Bays <span class="text-danger">*</span></label>
                    <input class="form-control" formControlName="baysBooked" type="number" />
                </div>

                <div class="form-group col-6">
                    <label>Price Per Bay (Including VAT) <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <div class="input-group-text">
                            <span>R</span>
                        </div>
                        <input class="form-control" formControlName="feeInRands" type="number" />
                    </div>
                </div>
            </div>

            <!-- Error -->
            <div *ngIf="formError" class="alert alert-danger mt-3" role="alert">
                {{ formError }}
            </div>

            <!-- Submit -->
            <div class="row mt-3">
                <div class="form-group col-12">
                    <button
                        [disabled]="!canSubmit"
                        class="btn btn-primary my-3"
                        type="submit"
                    >
                        <i class="fa-solid fa-credit-card"></i>
                        <span *ngIf="!formLoading"> Charge Saved Card &amp; Notify Landlord</span>
                        <span *ngIf="formLoading"> Processing...</span>
                    </button>
                    <p class="text-muted small mb-0" *ngIf="!hasCardOnFile && clientKey">
                        You must select a client with a saved card on file to enable this button.
                    </p>
                </div>
            </div>
        </form>
    </div>
</div>
